module.exports = __webpack_public_path__ + "img/icon-warning-drivingconditions-4.236632c6.svg";